import { useQuery } from '@tanstack/react-query';
import { experiencesGetEvents, ServiceEventResource } from '~/generated';
import { extractData } from '~/utils/query-utils';

type UseEventOptions = {
  experienceId: number;
  eventId: number;
};

export const useEvent = ({ experienceId, eventId }: UseEventOptions) => {
  return useQuery({
    queryFn: async () => {
      const events = await extractData(
        experiencesGetEvents({
          path: { experienceId },
          query: { filter: [`id=${eventId}`] },
        })
      );
      return events[0] as ServiceEventResource;
    },
    queryKey: ['Experiences', experienceId, 'Events', eventId],
  });
};
